import { useContext } from 'react';
import { QueryFunctionContext, useQuery } from 'react-query';
import { assignment_api } from '@axo/shared/data-access/api';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { parseUserKey, userKeys } from '../../cache-keys/userKeys';
import { queryFunction } from '../../query-function';

function assigneeParams({
  queryKey,
}: QueryFunctionContext<ReturnType<(typeof userKeys)['assignee']>>) {
  const { user, country } = parseUserKey(queryKey);

  return {
    Country: country,
    User: user,
  };
}

export function useAssignee(
  country: string,
  options?: { enabled?: boolean },
) {
  const {
    state: {
      user: { clientID },
    },
  } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = userKeys.assignee({
    user: clientID,
    country,
  });
  return useQuery(
    cacheKey,
    queryFunction(assignment_api.findAssignees(api), assigneeParams),
    {
      select: (result) => (result.Items.length ? result.Items[0] : null),
      enabled: options?.enabled ?? true,
    },
  );
}

function assigneesParams({
  queryKey,
}: QueryFunctionContext<ReturnType<(typeof userKeys)['assignee']>>) {
  const { country } = parseUserKey(queryKey);

  return {
    Country: country,
  };
}

export function useAssignees(country: string) {
  const api = useAPI();
  const cacheKey = userKeys.assignee({
    user: '',
    country,
  });
  return useQuery(
    cacheKey,
    queryFunction(assignment_api.findAssignees(api), assigneesParams),
    {
      select: (result) => result.Items,
    }
  );
}
